import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { cdpClient } from '../client';
import { activeProjectId } from '../projectScope';
import type { ScheduleAction } from '../types';

export interface ScheduleActionListFilters {
  src_goal?: string | null;
  dst_goal?: string | null;
  phone?: string | null;
}

const filters: ScheduleActionListFilters = {};

export function setScheduleActionListFilters(next: ScheduleActionListFilters): void {
  Object.assign(filters, next);
}

export const scheduleActionsAdapter: CrudAdapter<ScheduleAction, never, never> = {
  async list({ offset, limit }) {
    const query = {
      limit,
      offset,
      src_goal: filters.src_goal ?? undefined,
      dst_goal: filters.dst_goal ?? undefined,
      phone: filters.phone ?? undefined,
      project_id: activeProjectId.value ?? undefined,
    };
    const { data, error } = await cdpClient.GET('/schedule-actions', {
      params: { query: query as never },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async byKey(id) {
    const { data, error } = await cdpClient.GET('/schedule-actions/{schedule_id}', {
      params: { path: { schedule_id: String(id) } },
    });
    if (error) throw error;
    return data as ScheduleAction;
  },
};

export const scheduleActionsStore = useCrudDataSource(scheduleActionsAdapter, { keyExpr: 'id' });
